export const importance = {
  HIGH: '상',
  INTERMEDIATE: '중',
  LOW: '하',
};
